export const toggleSwitchItems = [
  { label: 'All', value: 'all' },
  { label: 'Past', value: 'past' }
];
